import { AnimationDuration } from "@/constants/UI";
import { useAppSelector } from "@/store/hooks";
import {
  selectIsSMTFilePickerModalOpen,
  useSMTDispatch,
} from "@/store/reducers/smt";
import type { SMTImagePickerModalProps } from "@/ui/components/smt/SMTImagePickerModal";
import SMTImagePickerModal from "@/ui/components/smt/SMTImagePickerModal";

interface AddSMTEntryImagePickerModalProps {
  onAssetPickerLaunch: SMTImagePickerModalProps["onAssetPickerLaunch"];
  onAssetSelected: () => void;
  uiConfig?: SMTImagePickerModalProps["uiConfig"];
}

const AddSMTEntryImagePickerModal = ({
  onAssetPickerLaunch,
  onAssetSelected,
  uiConfig,
}: AddSMTEntryImagePickerModalProps) => {
  const { setIsFilePickerModalOpen, setPhoto } = useSMTDispatch();

  const isSMTFilePickerModalOpen = useAppSelector(
    selectIsSMTFilePickerModalOpen,
  );

  const handleAssetSelected = (asset: FilePickerAsset | null) => {
    setPhoto(asset);
    // Since the Expo 52 upgrade, there now appears to be a UI race condition that locks the UI thread and prevents the modal from opening
    // This is a temporary workaround to ensure the modal opens after the photo is selected
    setTimeout(() => {
      onAssetSelected();
    }, AnimationDuration.ModalDismiss);
  };

  const handleFilePickerModalDismiss = () => {
    setIsFilePickerModalOpen(false);
  };

  return (
    <SMTImagePickerModal
      isOpen={isSMTFilePickerModalOpen}
      onAssetPickerLaunch={onAssetPickerLaunch}
      onAssetSelected={handleAssetSelected}
      onDismiss={handleFilePickerModalDismiss}
      onSkipPhoto={() => handleAssetSelected(null)}
      uiConfig={uiConfig}
    />
  );
};

export default AddSMTEntryImagePickerModal;
